import { Grid2 } from "@mui/material";
import styles from "./NoDataStyle.module.scss";

import { ReactComponent as NoDataIcon } from "../../GlobalAssets/svg/NoData.svg";

//global variables
// const useStyles = makeStyles(styles);

export default function NoData(props) {
  //props and hooks
  const { message, noDataStyle, ...rest } = props;
  // const classes = useStyles();
  return (
    <Grid2 {...rest} className={`${styles.displayFlexjustifyContentCenter} ${noDataStyle}`}>
      <Grid2 className={styles.textAlignCenter}>
        <NoDataIcon className={styles.noDataImage} />
        <p className={styles.noDataText}>{message}</p>
      </Grid2>
    </Grid2>
  );
}
